__turbopack_context__.v({
  "container": "ExchangeStepper-module-scss-module__OUaH0W__container",
  "content-container": "ExchangeStepper-module-scss-module__OUaH0W__content-container",
  "purchase-price": "ExchangeStepper-module-scss-module__OUaH0W__purchase-price",
  "purchased": "ExchangeStepper-module-scss-module__OUaH0W__purchased",
  "select-button": "ExchangeStepper-module-scss-module__OUaH0W__select-button",
});
